/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { Autocomplete, Box, Button, TextField } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { toast } from 'react-toastify';
import moment from 'moment';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { getTeamFilter, getRepFilter, getGroupFilter } from '../../../api/filterOptionsApi';
// Helpers
import {
  filterValue,
  filterMultiValue,
  filterTeamOptions,
  filterRepOptions,
  filterGroupOptions,
} from '../../../helpers/filterFunctions';
import useTeamDashboardContext from '../context/useTeamDashboardContext';

export default function Filter() {
  const { filterForm, setFilterForm, handleGenerateReport, handleClearReport } =
    useContext(useTeamDashboardContext);

  const [teamOptions, setTeamOptions] = useState([]);
  const [repOptions, setRepOptions] = useState([]);
  const [groupOptions, setGroupOptions] = useState([]);

  const loadTeamDropdown = async () => {
    const request = {
      rep_id: filterValue(filterForm?.rep_id),
      group: filterMultiValue(filterForm?.group),
      date_from: moment(filterForm?.date_from).format('YYYY-MM-DD'),
      date_to: moment(filterForm?.date_to).format('YYYY-MM-DD'),
    };
    const reponse = await getTeamFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterTeamOptions(data);
      setTeamOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadRepDropdown = async () => {
    const request = {
      team: filterMultiValue(filterForm?.team),
      group: filterMultiValue(filterForm?.group),
      date_from: moment(filterForm?.date_from).format('YYYY-MM-DD'),
      date_to: moment(filterForm?.date_to).format('YYYY-MM-DD'),
    };
    const reponse = await getRepFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterRepOptions(data);
      setRepOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadGroupDropdown = async () => {
    const request = {
      team: filterMultiValue(filterForm?.team),
      rep_id: filterValue(filterForm?.rep_id),
      date_from: moment(filterForm?.date_from).format('YYYY-MM-DD'),
      date_to: moment(filterForm?.date_to).format('YYYY-MM-DD'),
    };
    const reponse = await getGroupFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterGroupOptions(data);

      setGroupOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };
  const handleChangeDate = (label, value) => {
    if (label === 'date_from') {
      setFilterForm({
        ...filterForm,
        date_from: moment(value).format('YYYY-MM-DD'),
        date_to: moment(value).endOf('month').format('YYYY-MM-DD'),
      });
      return;
    }
    if (label === 'date_to') {
      if (!moment(filterForm?.date_from).isSame(value, 'month')) {
        toast.warning('Please select date within selected month');
        return;
      }
    }

    setFilterForm({ ...filterForm, [label]: moment(value).format('YYYY-MM-DD') });
  };
  const handleChangeFilter = (e, row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };

  useEffect(() => {
    loadTeamDropdown();
    loadRepDropdown();
    loadGroupDropdown();
  }, [filterForm]);
  return (
    <Box>
      <Grid container spacing={2}>
        <Grid md={2}>
          <Autocomplete
            id='team'
            multiple
            fullWidth
            filterOptions={(x) => x}
            options={teamOptions}
            autoComplete
            includeInputInList
            filterSelectedOptions
            getOptionLabel={(option) => (option.label ? option.label : '')}
            value={Array.isArray(filterForm.team) ? filterForm.team : []}
            noOptionsText='No Team'
            onChange={(event, newValue) => {
              let updatedNewValue = newValue;

              if (newValue.length === 0) {
                // if remove all month option set default to all
                updatedNewValue = [teamOptions[0]];
              } else if (newValue[newValue.length - 1].value === null) {
                // if last selected in ALL, remove all other options and retain ALL
                updatedNewValue = [teamOptions[0]];
              } else if (newValue.length !== 1) {
                // if selected other months, remove ALL in selected options
                updatedNewValue = newValue.filter(
                  (option) => option.value !== teamOptions[0].value,
                );
              }

              setFilterForm({
                ...filterForm,
                team: updatedNewValue,
              });
            }}
            isOptionEqualToValue={(option, selected) => option.value === selected.value}
            renderInput={(params) => <TextField {...params} label='Team' fullWidth />}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            size='small'
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='rep_id'
            disableClearable
            fullWidth
            options={repOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='MPR' />}
            size='small'
            value={filterForm?.rep_id}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'rep_id')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            id='group'
            multiple
            fullWidth
            filterOptions={(x) => x}
            options={groupOptions}
            autoComplete
            includeInputInList
            filterSelectedOptions
            getOptionLabel={(option) => (option.label ? option.label : '')}
            value={Array.isArray(filterForm.group) ? filterForm.group : []}
            noOptionsText='No Group'
            onChange={(event, newValue) => {
              let updatedNewValue = newValue;

              if (newValue.length === 0) {
                // if remove all month option set default to all
                updatedNewValue = [groupOptions[0]];
              } else if (newValue[newValue.length - 1].value === null) {
                // if last selected in ALL, remove all other options and retain ALL
                updatedNewValue = [groupOptions[0]];
              } else if (newValue.length !== 1) {
                // if selected other months, remove ALL in selected options
                updatedNewValue = newValue.filter(
                  (option) => option.value !== groupOptions[0].value,
                );
              }

              setFilterForm({
                ...filterForm,
                group: updatedNewValue,
              });
            }}
            isOptionEqualToValue={(option, selected) => option.value === selected.value}
            renderInput={(params) => <TextField {...params} label='Group' fullWidth />}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            size='small'
          />
        </Grid>
        <Grid md={1}>
          <DesktopDatePicker
            label='Date From'
            inputFormat='MM/DD/YYYY'
            value={filterForm?.date_from}
            onChange={(e) => handleChangeDate('date_from', e)}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField size='small' {...params} />}
          />
        </Grid>
        <Grid md={1}>
          <DesktopDatePicker
            label='Date To'
            inputFormat='MM/DD/YYYY'
            value={filterForm?.date_to}
            fullWidth
            onChange={(e) => handleChangeDate('date_to', e)}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField size='small' {...params} />}
          />
        </Grid>
        <Grid md={2}>
          <Button variant='contained' color='success' onClick={handleGenerateReport}>
            Generate
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={handleClearReport}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
